import T4A from '../components/T4A'

function T4AInfo() {
  return (
    <div>
      <T4A />
    </div>
  )
}

export default T4AInfo
